module.exports = __webpack_public_path__ + "img/absent-time.36a82398.png";